export const GET_MONITOR = 'GET_MONITOR';
export const LOADING_MONITOR = 'LOADING_MONITOR';
export const SAVE_LOADER_MONITOR = 'SAVE_LOADER_MONITOR'